import { SortOrder, MONTHS } from '../constants'

const VIEW_MODES = {
  BOTH: 'both',
  SUCCESS: 'success',
  FOURXX: 'fourxx',
}

const VIEW_MODE_LABELS = {
  [VIEW_MODES.BOTH]: 'Both',
  [VIEW_MODES.SUCCESS]: 'Success',
  [VIEW_MODES.FOURXX]: '4xx',
}

const SUCCESS_MAP_KEY = 'monthlySuccessHits'
const FOURXX_MAP_KEY = 'monthly4xxHits'
const HRT_MAP_KEY = 'highResTelemetrySites'

const PAGE_TITLE = 'API Hits Viewer'

const FROM_DEFAULT = '202601'
const TO_DEFAULT = '202612'

const ALL_ACCOUNTS_LABEL = 'All Accounts'

const CSV_FILE_PREFIX = 'api_hits'
const HRT_CSV_FILE_PREFIX = 'high_res_telemetry_sites'

const GRAND_TOTAL_LABEL = 'Grand Total'

const TOTAL_SUCCESS_LABEL = 'Total Success'
const TOTAL_FOURXX_LABEL = 'Total 4xx'
const TOTAL_HRT_LABEL = 'Total Sites'

const HRT_SECTION_TITLE = 'High-Res Telemetry Sites'

const STAT_LABELS = {
  ACCOUNTS: 'Accounts',
  MONTHS: 'Months',
  TOTAL_SUCCESS: 'Total Success',
  TOTAL_FOURXX: 'Total 4xx',
}

const EMPTY_TABLE_TEXT = 'No data available. Enter date range and click Fetch & Render.'
const HRT_EMPTY_TABLE_TEXT = 'No high-res telemetry data available.'

const FETCH_ERROR_MESSAGE = 'Failed to fetch API hits data'

export {
  SortOrder,
  VIEW_MODES,
  VIEW_MODE_LABELS,
  SUCCESS_MAP_KEY,
  FOURXX_MAP_KEY,
  HRT_MAP_KEY,
  PAGE_TITLE,
  FROM_DEFAULT,
  TO_DEFAULT,
  ALL_ACCOUNTS_LABEL,
  CSV_FILE_PREFIX,
  HRT_CSV_FILE_PREFIX,
  GRAND_TOTAL_LABEL,
  TOTAL_SUCCESS_LABEL,
  TOTAL_FOURXX_LABEL,
  TOTAL_HRT_LABEL,
  HRT_SECTION_TITLE,
  STAT_LABELS,
  EMPTY_TABLE_TEXT,
  HRT_EMPTY_TABLE_TEXT,
  FETCH_ERROR_MESSAGE,
  MONTHS,
}
